module.exports = __webpack_public_path__ + "static/318243694_666024418527330_3637593781471252150_n.jpg-1671186393155-a0d974f64357846cd134dd3e43453562.webp";